//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HomeHistoryGames from './HomeHistoryGames.vue';


import { Multiplier } from '../wheel.entity';

export default {
  name: 'WheelHomeHistory',
  components: {
    HomeHistoryGames
  },
  props: {
    // 颜色统计数据 (如: { X2: 40, X3: 30, X4: 20, X35: 10 })
    colorStats: {
      type: Object,
      default: () => null
    },
    // 历史游戏列表
    history: {
      type: Array,
      default: () => []
    },
    // 主播模式开关
    streamerMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Multiplier
    };
  },
  computed:{
    currencyType() {
      return Number(this.$route.meta?.currencyType ?? this.$route.query.currencyType ?? 0);
    },
		wheelHistoryRouteName() {
			if (this.currencyType === 1) return 'happyCoinWheelHistory';
			if (this.currencyType === 2) return 'coin1WheelHistory';
			return 'wheelHistory';
		},
  },
};
